import React from 'react';

function OpenEndedQuestion({ value, onChange, maxLength = 500 }) {
  const nearLimit = value.length >= maxLength * 0.9;
  return (
    <div className="open-ended-question">
      <textarea
        className="survey-textarea"
        value={value}
        maxLength={maxLength}
        rows={4}
        placeholder="Type your response here..."
        onChange={(e) => onChange(e.target.value)}
      />
      <div className={`char-count${nearLimit ? ' char-count--near-limit' : ''}`}>{value.length}/{maxLength}</div>
    </div>
  );
}

export default OpenEndedQuestion;
